import { useEffect } from 'react';

const GTM_ID = 'GTM-5TMM6N7B';

/**
 * Google Tag Manager <head> snippet with Consent Mode v2 defaults.
 *
 * Hydration-safe design (#1558):
 * - The inline bootstrap script (consent defaults + dataLayer init +
 *   gtm.start event) is rendered on the server. It only writes to
 *   dataLayer — no DOM mutation, no hydration risk.
 * - The gtm.js loader is injected via useEffect, which runs AFTER React
 *   hydration completes. Required because when gtm.js executes it fetches
 *   container config and dynamically creates additional <script> tags
 *   (GA4, Google Ads, etc.) in <head>. If that happened mid-hydration,
 *   React would see the extra DOM nodes and throw error #418.
 * - Consent defaults, gtm.start, and user interactions all enqueue into
 *   dataLayer; gtm.js processes the queue on load, so no events are lost.
 */
export function GoogleTagManager() {
  useEffect(() => {
    // Guard against double-insertion under React 18 StrictMode / fast-refresh.
    if (document.querySelector('script[data-tr-gtm]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    script.dataset.trGtm = '1';
    document.head.appendChild(script);
  }, []);

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'functionality_storage': 'granted',
  'personalization_storage': 'denied',
  'security_storage': 'granted',
  'wait_for_update': 500
});
window.dataLayer.push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
          `.trim(),
      }}
    />
  );
}

/**
 * GTM <noscript> fallback — place immediately after <body>.
 */
export function GoogleTagManagerNoscript() {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
}
